import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { config } from '../config';
import { useNotification } from '../components/Notification';
import './Login.css';

function CustomerLogin() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { showNotification } = useNotification();
  const tenantId = searchParams.get('tenantId') || '';
  const emailParam = searchParams.get('email') || '';
  const passwordParam = searchParams.get('password') || '';
  
  const [formData, setFormData] = useState({
    email: emailParam,
    password: passwordParam
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    try {
      const response = await fetch(`${config.API_URL || '/api'}/customer-auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: formData.email,
          password: formData.password,
          tenantId: tenantId || undefined
        })
      });

      const data = await response.json();

      if (!response.ok) {
        if (data.emailNotVerified) {
          showNotification('Bitte bestätigen Sie zuerst Ihre E-Mail-Adresse', 'error');
          return;
        }
        throw new Error(data.error || 'Anmeldung fehlgeschlagen');
      }

      localStorage.setItem('customerToken', data.token);
      localStorage.setItem('customer', JSON.stringify(data.customer));
      if (data.customer.tenantId) {
        localStorage.setItem('customerTenantId', data.customer.tenantId);
      } else {
        localStorage.removeItem('customerTenantId');
      }
      
      showNotification('Erfolgreich angemeldet', 'success');
      setTimeout(() => {
        navigate('/customer-dashboard');
      }, 100);
    } catch (error) {
      console.error('Login error:', error);
      showNotification(error.message || 'Fehler bei der Anmeldung', 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (emailParam && passwordParam && formData.email && formData.password) {
      const timer = setTimeout(() => {
        const form = document.querySelector('form');
        if (form && !loading) {
          form.requestSubmit();
        }
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [emailParam, passwordParam, formData.email, formData.password, loading]);

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Kunden-Login</h1>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>E-Mail</label>
            <input
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
            />
          </div>
          <div className="form-group">
            <label>Passwort</label>
            <input
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              required
            />
          </div>
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Anmeldung...' : 'Anmelden'}
          </button>
        </form>
        <div style={{ marginTop: '1.5rem', textAlign: 'center' }}>
          <p style={{ marginBottom: '0.5rem' }}>
            Noch nicht registriert?{' '}
            <Link 
              to={tenantId ? `/customer-register?tenantId=${tenantId}` : '/customer-register'}
              style={{ color: '#2196f3', fontWeight: '600', textDecoration: 'none' }}
            >
              Jetzt registrieren
            </Link>
          </p>
          <p style={{ marginTop: '1rem', fontSize: '0.875rem', color: '#666' }}>
            Oder{' '}
            <Link 
              to="/customer-login?email=testkunde@example.com&password=test123"
              style={{ color: '#2196f3', fontWeight: '600', textDecoration: 'none' }}
            >
              Demo-Konto verwenden
            </Link>
          </p>
        </div>
      </div>
      
      <footer className="login-footer">
        <div className="login-footer-content">
          <Link 
            to="/customer-login?email=testkunde@example.com&password=test123"
            className="login-footer-link demo-link"
            style={{ fontWeight: '600', color: '#2196f3' }}
          >
            Kunde Demo
          </Link>
          <Link 
            to="/login?demo=true"
            className="login-footer-link demo-link"
            style={{ fontWeight: '600', color: '#2196f3' }}
          >
            Werkstatt Demo
          </Link>
          <Link to="/customer-register" className="login-footer-link">
            Registrieren
          </Link>
          <Link to="/support" className="login-footer-link">
            Support
          </Link>
          <Link to="/impressum" className="login-footer-link">
            Impressum
          </Link>
          <Link to="/datenschutz" className="login-footer-link">
            Datenschutz
          </Link>
        </div>
      </footer>
    </div>
  );
}

export default CustomerLogin;
